"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GettextKind = void 0;
var GettextKind;
(function (GettextKind) {
    GettextKind[GettextKind["invalid"] = 0] = "invalid";
    GettextKind[GettextKind["gettext"] = 1] = "gettext";
    GettextKind[GettextKind["ngettext"] = 2] = "ngettext";
    GettextKind[GettextKind["pgettext"] = 3] = "pgettext";
    GettextKind[GettextKind["npgettext"] = 4] = "npgettext";
})(GettextKind || (exports.GettextKind = GettextKind = {}));
//# sourceMappingURL=types.js.map